import script from "./Absence.vue?vue&type=script&setup=true&lang=js"
export * from "./Absence.vue?vue&type=script&setup=true&lang=js"

import "./Absence.vue?vue&type=style&index=0&id=5820d41e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5820d41e"]])

export default __exports__